"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliceKey = exports.reducer = exports.searchProviderActions = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const react_fast_compare_1 = __importDefault(require("react-fast-compare"));
const api_1 = require("astra-core/utils/api");
const REDUCER_KEY = 'searchProviderV2';
const initialState = {
    main: {
        entries: {
            lineEvents: [],
            liveEvents: [],
            tournaments: [],
        },
        fetchItems: api_1.requestInitialState,
    },
    searchPage: {
        filters: {
            searchQuery: '',
            sportIds: undefined,
        },
        tournaments: {
            fetchItems: api_1.requestInitialState,
            entries: [],
        },
    },
};
const searchProviderSlice = (0, toolkit_1.createSlice)({
    name: REDUCER_KEY,
    initialState,
    reducers: {
        fetchSearchMain(state, _action) {
            state.main.fetchItems.error = null;
            state.main.fetchItems.loading = true;
        },
        fetchSearchMainSuccess(state, { payload }) {
            state.main.entries = payload;
            state.main.fetchItems.loading = false;
            state.main.fetchItems.error = null;
        },
        fetchSearchMainError(state, { payload }) {
            state.main.entries = {
                lineEvents: [],
                liveEvents: [],
                tournaments: [],
            };
            state.main.fetchItems.loading = false;
            state.main.fetchItems.error = payload;
        },
        setSearchQuery(state, { payload }) {
            state.searchPage.filters.searchQuery = payload.searchQuery;
        },
        setSportIds(state, { payload }) {
            state.searchPage.filters.sportIds = payload.sportIds;
        },
        resetFilters(state) {
            state.searchPage.filters = initialState.searchPage.filters;
        },
        fetchTournaments(state) {
            state.searchPage.tournaments.fetchItems.error = null;
            state.searchPage.tournaments.fetchItems.loading = true;
        },
        fetchTournamentsSuccess(state, { payload }) {
            if (!(0, react_fast_compare_1.default)(state.searchPage.tournaments.entries, payload.tournaments)) {
                state.searchPage.tournaments.entries = payload.tournaments;
            }
            state.searchPage.tournaments.fetchItems.loading = false;
            state.searchPage.tournaments.fetchItems.error = null;
        },
        fetchTournamentsError(state, { payload }) {
            state.searchPage.tournaments.entries = [];
            state.searchPage.tournaments.fetchItems.loading = false;
            state.searchPage.tournaments.fetchItems.error = payload;
        },
    },
});
exports.searchProviderActions = searchProviderSlice.actions, exports.reducer = searchProviderSlice.reducer, exports.sliceKey = searchProviderSlice.name;
//# sourceMappingURL=slice.js.map